/**
 * Dynamically embed a Resurva appointment widget into the Resurva modal
 * @param {string} embedCode
 */
export function openResurvaModal(embedCode) {
	const $modal = $('#modal--resurva')
	$modal.find('.modal-body').html(embedCode)
	$modal.modal('show')
}